<template>
  <div>
    <div class="table__block">
      <el-table
        v-if="showTable"
        :data="dataTable"
        height="513"
      >
        <el-table-column
          label="Tên kỳ"
        >
          <el-table-column label="Kê khai theo mã nhân viên" min-width="75" align="center">
            <template slot-scope="scope">
              <a
                :href="
                  scope.row.salary_period_id == 'Tổng cộng'
                    ? 'javascipt:0'
                    : `/admin/SalaryEmployee/list?salary_period_id=${scope.row.salary_period_id}&tab=Tax`
                "
                class="custom__link"
                @click="goToEmployeeSalary(scope.row.salary_period_id)"
              >
                {{ getNamePeriod(scope.row.salary_period_id) }}
              </a>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="Thu nhập tính thuế TNCN"
        >
          <el-table-column
            label="Thu nhập chịu thuế"
            min-width="60"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.income_tax) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Giảm trừ gia cảnh"
            min-width="60"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.family_allowances) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Ủng hộ"
            min-width="60"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.donate) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Bảo hiểm bắt buộc"
            min-width="60"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.compulsory_insurance) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Thu nhập tính thuế"
            min-width="60"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.taxable_income) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Tỷ lệ giảm thuế TNCN do có TN tại khu kinh tế"
            min-width="60"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.reduction_rate }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="button__block mt-3 text-right">
      <el-button
        :disabled="dataTable.length == 0"
        type="primary"
        class="btn-export"
        @click="exportReport"
      >
        <i class="icon icon24-Download"></i>
        <span>Xuất báo cáo</span>
      </el-button>
    </div>
  </div>
</template>

<script>
import MethodService from '../../../../service/MethodService'
import TaxApi from '../../../../moduleApi/TaxApi'
import EventBus from "@/service/EventBus"

export default {
  props: {
    fromPeriodProp: {
      type: String,
      default: undefined
    },
    toPeriodProp: {
      type: String,
      default: undefined
    },
    listSalaryPeriod: {
      type: Array,
      default: (() => [])
    },
    keySubmit: {
      type: String,
      default: undefined
    },
  },
  watch: {
    keySubmit(newVal) {
      if (this.$route.query.tab && this.$route.query.tab == 'tax') {
        this.dataTable = []
        console.log('newVal Tax', newVal)
        setTimeout(() => {
          this.getDataTax()
        }, 500)
      }
    },
  },
  data() {
    return {
      MethodService,
      dataTable: [],
      showTable: true,
    }
  },
  methods: {
    // Exporting the data to excel file.
    exportReport() {
      MethodService.exportTax(
        this.dataTable,
        this.listSalaryPeriod,
        this.getNamePeriod(this.fromPeriodProp),
        this.getNamePeriod(this.toPeriodProp)
      )
    },
    // This function is used to redirect to the page `Admin-SalaryEmployee-list` with the query
    // `salary_period_id` and `tab`
    goToEmployeeSalary(salaryPeriodId) {
      if (salaryPeriodId == 'Tổng cộng') return
      this.$router.push({
        name: 'Admin-SalaryEmployee-list',
        query: {
          salary_period_id: salaryPeriodId,
          tab: 'Tax'
        }
      }).catch(() => {})
    },
    // This function is used to get the data from the API `TaxApi.GetTaxes` and then change the data to
    // the format that we want.
    async getDataTax() {
      let data = {
        from_date: this.getStartTimePeriod(this.fromPeriodProp),
        to_date: this.getEndTimePeriod(this.toPeriodProp)
      }
      const getTaxApiRes = await TaxApi.GetTaxes(data)
      this.dataTable = this.changeData(getTaxApiRes.result)
    },
    // This function is used to add a new row to the table with the name `Tổng cộng` and the value of
    // each column is the sum of the value of each column in the table.
    changeData(data) {
      if (data.length == 0) return data
      let obj = {
        salary_period_id: 'Tổng cộng',
        income_tax: 0,
        family_allowances: 0,
        donate: 0,
        compulsory_insurance: 0,
        taxable_income: 0,
        reduction_rate: 0,
      }
      data.forEach(item => {
        obj.income_tax += item.income_tax
        obj.family_allowances += item.family_allowances
        obj.donate += item.donate
        obj.compulsory_insurance += item.compulsory_insurance
        obj.taxable_income += item.taxable_income
        obj.reduction_rate += item.reduction_rate
      })
      data.push(obj)
      return data
    },
    // This function is used to get the name of a period.
    getNamePeriod(id) {
      if (id == 'Tổng cộng') return id
      let a = this.listSalaryPeriod.find(item => item.id == id)
      return a.name_period.replace('Tháng ','')
    },
    // A function to get the start time of a period.
    getStartTimePeriod(id) {
      let period = this.listSalaryPeriod.find(e => e.id == id)
      return period && period.from_date ? period.from_date : undefined
    },
    // A function to get the end time of a period.
    getEndTimePeriod(id) {
      let period = this.listSalaryPeriod.find(e => e.id == id)
      return period && period.before_to_date ? period.before_to_date : undefined
    },
  },
  created() {
    EventBus.$off('changeSizeMenuTax')
    EventBus.$on('changeSizeMenuTax', () => {
      this.showTable = false
      setTimeout(() => {
        this.showTable = true
      }, 50)
    })
  }
}
</script>

<style lang="scss" scoped>
.table__block {
  min-height: 513px;
}
.custom__link {
  color: #1E3CD7;
  font-family: 'LexendDeca Regular';
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  text-decoration: underline;
}
</style>
